// extracted by mini-css-extract-plugin
export default {"varriant1":"InputVariants_varriant1__kFNSj","varriant1_input":"InputVariants_varriant1_input__ZSR3k","varriant1_icon":"InputVariants_varriant1_icon__lLA4Z"};